import { createRouter, createWebHistory } from 'vue-router'
import i18n from './i18n'

const Home = () => import('./components/Home.vue')
const AboutProject = () => import('./components/home/AboutProject.vue')
const Articles = () => import('./components/home/Articles.vue')
const Article = () => import('./components/home/Article.vue')
const BonusAccount = () => import('./components/settings/BonusAccount.vue')
const RatePlans = () => import('./components/home/RatePlans.vue')
const Faq = () => import('./components/home/Faq.vue')
const Question = () => import('./components/home/Question.vue')
const Instruction = () => import('./components/home/Instruction.vue')
const InstructionPage = () => import('./components/home/InstructionPage.vue')
const Page = () => import('./components/Page.vue')
const Login = () => import('./components/Login.vue')
const LoginNca = () => import('./components/LoginNca.vue')
const LoginEdocument = () => import('./components/LoginEdocument.vue')
const Dashboard = () => import('./components/Dashboard.vue')
const Users = () => import('./components/Users.vue')
const User = () => import('./components/User.vue')
const Registration = () => import('./components/Registration.vue')
const Verify = () => import('./components/Verify.vue')
const ChangeEmail = () => import('./components/ChangeEmail.vue')
const ResetPassword = () => import('./components/ResetPassword.vue')
const ClaimsNew = () => import('./components/claims/New.vue')
const ClaimsImport = () => import('./components/claims/ClaimsImport.vue')
const Claim = () => import('./components/claims/Claim.vue')
const ClaimsInbox = () => import('./components/claims/Inbox.vue')
const ClaimsOutbox = () => import('./components/claims/Outbox.vue')
const ClaimShort = () => import('./components/claims/ClaimShort.vue')
const Edit = () => import('./components/claims/Edit.vue')
const PartnerLink = () => import('./components/PartnerLink.vue')
const PaymentSchedules = () => import('./components/payment-schedules/All.vue')
const PretrialAgreement = () => import('./components/claims/PretrialAgreement.vue')
const Profile = () => import('./components/settings/Profile.vue')
const Receipt = () => import('./components/Receipt.vue')
const Recipients = () => import('./components/recipients/All.vue')
const RecipientsNew = () => import('./components/recipients/New.vue')
const Recipient = () => import('./components/recipients/Recipient.vue')
const Rates = () => import('./components/settings/Rates.vue')
const TemplateEditor = () => import('./components/claims/TemplateEditor.vue')
const NotFound = () => import('./components/NotFound.vue')
const SavedImport = () => import('./components/claims/SavedImport.vue')
const DebtNoticeHome = () => import('./components/debt/DebtNoticeHome.vue')
const OutboxDebtNotice = () => import('./components/debt/Outbox.vue')
const InboxDebtNotice = () => import('./components/debt/Inbox.vue')
const NewDebtNotice = () => import('./components/debt/New.vue')
const EditDebtNotice = () => import('./components/debt/Edit.vue')
const Notice = () => import('./components/debt/Notice.vue')
const DebtImport = () => import('./components/debt/DebtImport.vue')
const LoginMain = () => import('./components/LoginMain.vue')
const AddressMigrator = () => import('./components/AddressMigrator.vue')
const OSIMain = () => import('./components/osi/OSIMain.vue')
const OsiSettings = () => import('./components/osi/OsiSettings.vue')
const OsiManagement = () => import('./components/osi/OsiManagement.vue')
const Notifications = () => import('./components/cabinet/Notifications.vue')

const pkbSmsEnabled = process.env.VUE_APP_PKB_SMS_API_ENABLED === 'true'

const routes = [
    { path: '/', component: Home },
    { path: '/:lang', component: Home, meta: { breadcrumb: false } },
    { path: '/login', component: Login },
    { path: '/login/main', component: LoginMain },
    { path: '/login/nca', component: LoginNca },
    pkbSmsEnabled
        ? { path: '/login/edocument', component: LoginEdocument }
        : { path: '/login/edocument', redirect: '/login/main' },
    // { path: '/registration', component: Registration },
    { path: '/verify/:hash', component: Verify },
    { path: '/change-email/:hash', component: ChangeEmail },
    { path: '/reset-password', component: ResetPassword },
    { path: '/reset-password/:hash', component: ResetPassword },
    {
        path: '/address-migrator',
        component: AddressMigrator,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/about',
        name: 'AboutProject',
        component: AboutProject,
        meta: {
            breadcrumb: `О проекте`
        }
    },
    {
        path: '/:lang/articles',
        name: 'Articles',
        component: Articles,
        meta: {
            breadcrumb(route, app) {
                let language = route.path.substring(1, 3)
                let title = i18n.global.t('articles.title', language)

                return `${title}`
            }
        }
    },
    {
        path: '/:lang/articles/:slug',
        component: Article,
        meta: {
            breadcrumb(route, app) {
                let language = route.path.substring(1, 3)
                let title = i18n.global.t('articles.title', language)

                return `${title}`
            }
        }
    },
    {
        path: '/:lang/rate-plans',
        name: 'RatePlans',
        component: RatePlans,
        meta: {
            breadcrumb: `Тарифные планы`
        }
    },
    {
        path: '/:lang/faq',
        name: 'Faq',
        component: Faq,
        meta: {
            breadcrumb(route, app) {
                let language = route.path.substring(1, 3)
                let title = i18n.global.t('faq.title', language)

                return `${title}`
            }
        }
    },
    {
        path: '/:lang/faq/:slug',
        component: Question,
        meta: {
            breadcrumb(route, app) {
                let language = route.path.substring(1, 3)
                let title = i18n.global.t('faq.title', language)

                return `${title}`
            }
        }
    },
    {
        path: '/:lang/instruction',
        name: 'Instruction',
        component: Instruction,
        meta: {
            breadcrumb(route, app) {
                let language = route.path.substring(1, 3)
                let title = i18n.global.t('instruction.title', language)
                
                return `${title}`
            }
        }
    },
    {
        path: '/:lang/instruction/:slug',
        component: InstructionPage,
        meta: {
            breadcrumb(route, app) {
                let language = route.path.substring(1, 3)
                let title = i18n.global.t('instruction.title', language)
                
                return `${title}`
            }
        }
    },
    {
        path: '/r/:slug',
        component: Receipt
    },
    {
        path: '/cabinet',
        redirect: '/dashboard',
        meta: {
            requiresAuth: true,
            isCabinet: true
        }
    },
    {
        path: '/dashboard',
        component: Dashboard,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb: 'Dashboard'
        }
    },
    {
        path: '/notifications',
        component: Notifications,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb: 'Уведомления'
        }
    },
    {
        path: '/c/:number',
        component: ClaimShort
    },
    {
        path: '/claims',
        component: ClaimsInbox,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb: 'Претензии'
        },
        redirect: '/claims/inbox'
    },
    {
        path: '/claims/new',
        component: ClaimsNew,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb: 'Новая'
        }
    },
    {
        path: '/debt-notice',
        component: DebtNoticeHome,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb: 'Уведомления о задолженности'
        }
    },
    {
        path: '/debt-notice/outbox',
        component: OutboxDebtNotice,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb: 'Исходящие'
        }
    },
    {
        path: '/debt-notice/inbox',
        component: InboxDebtNotice,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb: 'Входящие'
        }
    },
    {
        path: '/debt-notice/new',
        component: NewDebtNotice,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb: 'Новое уведомление'
        }
    },
    {
        path: '/debt-notice/import',
        component: DebtImport,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb: 'Импорт уведомлений'
        }
    },
    {
        path: '/debt-notice/:id',
        component: Notice,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb(route, app) {
                return `Уведомление о задолженности #${route.params.id}`
            }
        }
    },
    {
        path: '/debt-notice/:id/edit',
        component: EditDebtNotice,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb(route, app) {
                return 'Редактировать'
            }
        }
    },
    {
        path: '/claims/import',
        component: ClaimsImport,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb: 'Импорт из Excel'
        }
    },
    {
        path: '/claims/:id',
        component: Claim,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb(route, app) {
                return `Претензия #${route.params.id}`
            }
        }
    },
    {
        path: '/claims/:id/edit',
        component: Edit,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb(route, app) {
                return `Редактировать`
            }
        }
    },
    {
        path: '/claims/:id/template-editor',
        component: TemplateEditor,
        meta: {
            requiresAuth: true,
            isCabinet: true
        }
    },
    {
        path: '/claims/:slug/pretrial-agreement',
        component: PretrialAgreement,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb(route, app) {
                return `Сообщение`
            }
        }
    },
    {
        path: '/claims/inbox',
        component: ClaimsInbox,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb: 'Входящие'
        }
    },
    {
        path: '/claims/outbox',
        component: ClaimsOutbox,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb: 'Исходящие'
        }
    },
    {
        path: '/p/:p',
        component: PartnerLink
    },
    {
        path: '/payment-schedules',
        component: PaymentSchedules,
        meta: {
            requiresAuth: true,
            isCabinet: true
        }
    },
    {
        path: '/recipients',
        component: Recipients,
        meta: {
            requiresAuth: true,
            isCabinet: true
        }
    },
    {
        path: '/recipients/add',
        component: RecipientsNew,
        meta: {
            requiresAuth: true,
            isCabinet: true
        }
    },
    {
        path: '/recipients/:id',
        component: Recipient,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb(route, app) {
                return `Получатель #${route.params.id}`
            }
        }
    },
    // {
    //     path: '/users',
    //     component: Users,
    //     meta: {
    //         requiresAuth: true,
    //         isCabinet: true
    //     }
    // },
    // {
    //     path: '/users/:id',
    //     component: User,
    //     meta: {
    //         requiresAuth: true,
    //         isCabinet: true
    //     }
    // },

    { 
        path: '/osi',
        name: 'OSI',
        component: OSIMain,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb: 'ОСИ'
        }
    },
    {
        path: '/osi/settings',
        name: 'OSISettings',
        component: OsiSettings,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb: 'Настройки ОСИ'
        }
    },
    {
        path: '/osi/manage',
        name: 'OSIManagement',
        component: OsiManagement,
        meta: {
            requiresAuth: true,
            isCabinet: true,
            breadcrumb: 'Управление ОСИ'
        }
    },
    {
        path: '/settings/profile',
        component: Profile,
        meta: {
            requiresAuth: true,
            isCabinet: true
        }
    },
    {
        path: '/settings/rates',
        component: Rates,
        meta: {
            requiresAuth: true,
            isCabinet: true
        }
    },
    {
        path: '/template-editor',
        component: TemplateEditor,
        meta: {
            requiresAuth: true,
            isCabinet: true
        }
    },
    {
        path: '/saved-import',
        component: SavedImport,
        meta: {
            requiresAuth: true,
            isCabinet: true
        }
    },
    {
        path: '/404',
        name: '404',
        component: NotFound,
    },
    { 
        path: '/:lang/:slug',
        name: 'Page',
        component: Page,
        props: true,
        meta: {
            breadcrumb(route, app){
                return 'Страница'
            }
        }
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/404'
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
